import React from "react";
import { AdminProducerSummaryLoaderTemplate } from "themes/administration/producer/components";

function AdminProducerSummaryLoader(props) {
    return <AdminProducerSummaryLoaderTemplate {...props} />;
}

export default AdminProducerSummaryLoader;
